import React, { useEffect, useState } from "react";
import Footer from "../Footer/Footer";
import styles from "./Faq.module.css";
import FaqQuestion from "./FaqQuestion";
import { Link } from "react-scroll";

import HYPHEN_ICON from "../../assets/images/icons/hyphen_icon.jpg";

import FAQ_BAR_ICON from "../../assets/images/icons/line_bar_icon.png";
import axios from "axios";
import { linkProfile } from "../../constants";
const Faq = () => {
  const [data, setData] = useState(null);
  const backend_base = process.env.REACT_APP_API_BASE_URL;
  useEffect(() => {
    axios
      .get(backend_base + "/home/faq")
      .then((res) => {
        if (res.status === 201 || res.status === 200) {
          console.log("Success Getting Latest 2 news");
          console.log(res.data);
          setData(res.data.question_answer);
        } else {
          console.log("Failed Getting news");
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }, []);
  return (
    <>
      <div>
        <div className={`container d-flex ${styles.faq}`}>
          <div className={` ${styles.faqCategory}`}>
            <div className={styles.faq_header01}>よくあるご質問</div>
            {data &&
              Array.isArray(data) &&
              data.length > 0 &&
              data.map((d, index) => (
                <div className={styles.text98} key={index}>
                  <img
                    className={styles.hyphen_icon}
                    src={HYPHEN_ICON}
                    alt="hyphen icon"
                  />
                  <Link
                    to={d.cat_id}
                    spy={true}
                    smooth={true}
                    offset={-100}
                    duration={500}
                  >
                    {d.category}
                  </Link>
                </div>
              ))}
          </div>
          <div className={` ${styles.questionAnswer}`}>
            {data &&
              Array.isArray(data) &&
              data.length > 0 &&
              data.map((d, index) => (
                <div key={index} name={d.cat_id}>
                  <div className={styles.text97}>
                    <img
                      className={styles.hyphen_icon}
                      src={HYPHEN_ICON}
                      alt="hyphen icon"
                    />
                    {d.category}
                  </div>
                  {Array.isArray(d.question) &&
                    d.question.length > 0 &&
                    d.question.map((que, index) => (
                      <FaqQuestion key={index} name={que} />
                    ))}
                </div>
              ))}
            <div className={styles.line_box}>
              <div className={styles.text96}>
                お問い合わせやご質問は、Acestudio Official
                LINEにてお願いいたします。{" "}
              </div>
              <div className={styles.text95}>
                QRコードを読み取り、お友達登録後メッセージを送信してください。
              </div>
              <a href={linkProfile} style={{ textDecoration: "none" }}>
                <img
                  src={FAQ_BAR_ICON}
                  className={styles.line_icon}
                  alt="ads"
                />
              </a>
            </div>
          </div>
        </div>

        {/* <div className={`container  ${styles.line}`}>
          <h6 className={styles.linehead}>お問い合わせ</h6>
          <div className={`${styles.lineinfo}`}>
            <div className="d-flex">
              <div className={`d-flex flex-column`}>
                <div className={`d-flex ${styles.lineimgtxt}`}>
                  <img src={Faqline} alt="" />
                  <h5>LINE Official Account</h5>
                </div>
                <h5 className={styles.lineDetails}>
                  お問い合わせやご質問は、Acestudio Official
                  LINEにてお願いいたします。
                  <br />
                  QRコードを読み取り、お友達登録後メッセージを送信してください。
                </h5>
              </div>
              <div className={styles.qr}>
                <img src={Faqlineqr} alt="" />
              </div>
            </div>
          </div>
        </div> */}
      </div>
      <Footer />
    </>
  );
};

export default Faq;
